import { ViewIds } from '@ardoq/api-types';
import { PaneLocation } from 'streams/views/mainContent/types';

export const toViewpointModeMainViewInstanceId = (viewId: ViewIds): string =>
  `viewpoint-main-view-${viewId}`;

export const toWorkspaceModeMainViewInstanceId = (
  location: PaneLocation,
  viewId: ViewIds
): string => `workspace-main-view-${location}-${viewId}`;
